
// ModalContasAreceber.js

import React, { useState, useEffect, useCallback } from 'react';
//import Axios from 'axios';
import api from '../config/axiosConfig';

import './ModalContasAreceber.css';

function ModalCriarParcelas({ isOpen, fecharModal, codVenda, valVenda, dadosVenda }) {
  const [quantidadeParcelas, setQuantidadeParcelas] = useState(1);
  const [parcelas, setParcelas] = useState([]);
  const [loading, setLoading] = useState(false);
  const [mensagem, setMensagem] = useState("");
  const [parcelasExistentes, setParcelasExistentes] = useState([]);
  const [valorVenda, setValorVenda] = useState(0); // Aqui, capturamos o valor da venda do backend.
  
  const fetchParcelasExistentes = useCallback(() => {
    api.get(`/areceber/${codVenda}/areceber`)

      .then(response => {
        setParcelasExistentes(response.data);
        setParcelas(response.data);
      })
      .catch(error => {
        console.error('Erro ao buscar parcelas existentes:', error);
      });
  }, [codVenda]);

  // Nova função para buscar o valor da venda pelo codVenda.
  const fetchValorVenda = useCallback(() => {
    api.get(`/vendas/buscarvenda?codvenda=${codVenda}`)

      .then(response => {
        if (response.data && response.data.valvenda) {
          setValorVenda(response.data.valvenda);
        } else {
          console.error('Erro: Valor da venda não encontrado.');
        }
      })
      .catch(error => {
        console.error('Erro ao buscar valor da venda:', error);
      });
  }, [codVenda]);

  useEffect(() => {
    if (isOpen) {
      fetchParcelasExistentes();
      fetchValorVenda(); // Buscando o valor da venda ao abrir o modal
    }
  }, [isOpen, fetchParcelasExistentes, fetchValorVenda]);

  const gerarParcelas = () => {
    if (valorVenda > 0) {
      const novasParcelas = [];
      const valorParcela = valorVenda / quantidadeParcelas;

      for (let i = 1; i <= quantidadeParcelas; i++) {
        //const dtvencimento = new Date();
        const dtvencimento = new Date(dadosVenda.dtvenda); // Converter `dtvenda` para Date

        dtvencimento.setMonth(dtvencimento.getMonth() + i);

        novasParcelas.push({
          parcela: i,
          dtvencimento: dtvencimento.toISOString().split('T')[0],
          valparcela: valorParcela,
        });
      }

      setParcelas(novasParcelas);
    } else {
      console.error('Valor da venda é 0 ou não foi carregado corretamente');
    }
  };


  const handleSave = () => {
    setLoading(true);
    const dadosParcelas = parcelas.map(parcela => ({
      ...parcela,
      codvenda: dadosVenda.codvenda,
      dtvenda: dadosVenda.dtvenda,
      valvenda: dadosVenda.valvenda,
      nfvenda: dadosVenda.nfvenda,
      condpag: dadosVenda.condpag,
      formapag: dadosVenda.formapag,
      codcli: dadosVenda.codcli,
      nomecli: dadosVenda.nomecli,
      cnpjcli: dadosVenda.cnpjcli,
      codemp: dadosVenda.codemp,
      empresa: dadosVenda.empresa,
      cnpjemp: dadosVenda.cnpjemp,
      qtdparcelas: quantidadeParcelas,
    }));

    api.post(`/areceber/${codVenda}/areceber`, dadosParcelas)

      .then(response => {
        setMensagem('Parcelas salvas com sucesso!');
        setLoading(false);
        fecharModal();
      })
      .catch(error => {
        console.error('Erro ao salvar parcelas:', error);
        setMensagem('Erro ao salvar parcelas. Tente novamente.');
        setLoading(false);
      });
  };

  const handleDelete = () => {
    if (parcelas.length === 0) {
        setMensagem(`Nenhuma parcela encontrada para o código de venda: ${codVenda}`);
        return;
    }

    setLoading(true);
    api.delete(`/areceber/codvenda/${codVenda}`)

      .then(response => {
        if (response.status === 204) { // No content, parcelas excluídas com sucesso
          setParcelas([]);
          setMensagem('Parcelas excluídas com sucesso.');
        } else {
          setMensagem('Erro ao excluir parcelas. Tente novamente.');
        }
        setLoading(false);
      })
      .catch(error => {
        console.error('Erro ao excluir parcelas:', error);
        setMensagem('Erro ao excluir parcelas. Tente novamente.');
        setLoading(false);
      });
  };

  const handleCloseModal = () => {
    setParcelas([]);
    setMensagem("");
    fecharModal();
  };

  // Função para lidar com a mudança do valor no input e formatar o valor
  const handleParcelaChange = (index, field, value) => {
    const updatedParcelas = [...parcelas];
    if (field === 'valparcela') {
      // Remove caracteres não numéricos, exceto ponto (.) e vírgula (,)
      let numericValue = value.replace(/[^0-9,]/g, '').replace(',', '.');
      numericValue = parseFloat(numericValue);

      updatedParcelas[index][field] = numericValue;
    } else {
      updatedParcelas[index][field] = value;
    }
    setParcelas(updatedParcelas);
  };

  const formatarValorInput = (valor) => {
    if (!valor) return 'R$ 0,00';
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(valor);
  };

  if (!isOpen) return null;

  return (
    <div className="modal">
      <div className="modal-content">

      <span className="close" onClick={handleCloseModal}>&times;</span>

      <h3 translate="no">Contas a Receber da Venda: {codVenda}</h3>
      <div className="quantidade-parcelas-container">
        <label>Quantidade de Parcelas:</label>
        <input
          type="number"
          value={quantidadeParcelas}
          onChange={(e) => setQuantidadeParcelas(parseInt(e.target.value, 10))}
          min="1"
          className="quantidade-parcelas-input"
        />
        <button
          onClick={gerarParcelas}
          disabled={parcelasExistentes.length > 0}
          className="gerar-parcelas-btn"
        >
          Gerar Parcelas
        </button>
      </div>
        
        <table>
          <thead>
            <tr>
              <th>Parcela</th>
              <th>Vencimento</th>
              <th translate="no">Valor</th>
            </tr>
          </thead>
          <tbody>
            {parcelas.map((parcela, index) => (
              <tr key={index}>
                <td>{parcela.parcela}</td>
                <td>
                  <input
                    type="date"
                    value={parcela.dtvencimento}
                    onChange={(e) => handleParcelaChange(index, 'dtvencimento', e.target.value)}
                  />
                </td>
                <td>
                  <input
                    type="text"
                    value={formatarValorInput(parcela.valparcela)}
                    onChange={(e) => handleParcelaChange(index, 'valparcela', e.target.value)}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {mensagem && <p>{mensagem}</p>}
        <div className="button-container">
          <button className="excluir" onClick={handleDelete} disabled={loading}>
            {loading ? 'Excluindo...' : 'Excluir Parcelas'}
          </button>
          <button className="salvando" onClick={handleSave} disabled={parcelasExistentes.length > 0 || loading}>
            {loading ? 'Salvando...' : 'Salvar Parcelas'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default ModalCriarParcelas;